import {PresenterState} from '@cascade/core';
import {useEffect} from 'react';
import styles from './Editor.module.scss';
import {Footer} from './components/footer';
import {ElementSwitch, Navigation, ResizeableLayout} from './components/layout';
import {Settings, VideoSettings} from './components/sidebar';
import {Threads} from './components/sidebar/Threads';
import {Timeline} from './components/timeline';
import {Viewport} from './components/viewport';
import {usePanels} from './contexts';
import {useShortcutContext} from './contexts/shortcuts';
import {usePresenterState, useSignalValue} from './hooks';
import {EditorPanel} from './signals';

export function Editor() {
  const state = usePresenterState();
  const {sidebar, bottom} = usePanels();
  const sidebarTab = useSignalValue(sidebar.current);
  const bottomTab = useSignalValue(bottom.current);
  const {global} = useShortcutContext();

  useEffect(() => {
    // Always 'editor' context since Remotion has no presenter mode
    global.value = state === PresenterState.Initial ? 'editor' : 'presenter';
  }, [state]);

  // Remotion mode: always show editor (presenter stub returns Initial)
  return (
    <div className={styles.root}>
      <Navigation />
      <ResizeableLayout
        id={`main-timeline`}
        hidden={bottom.isHidden}
        offset={-160}
        vertical
      >
        <ResizeableLayout
          id={`sidebar-viewport`}
          hidden={sidebar.isHidden}
          offset={400}
        >
          <ElementSwitch
            value={sidebarTab}
            cases={{
              [EditorPanel.VideoSettings]: VideoSettings,
              [EditorPanel.Threads]: Threads,
              [EditorPanel.Settings]: Settings,
            }}
          />
          <Viewport />
        </ResizeableLayout>
        <ElementSwitch
          value={bottomTab}
          cases={{
            [EditorPanel.Timeline]: Timeline,
          }}
        />
      </ResizeableLayout>
      <Footer />
    </div>
  );
}
